export default ".lesson-nav-preview {\n  opacity: 0.6;\n}";